import { Directive, HostListener, inject, Input } from '@angular/core';
import { SearchService } from '@df/search/search.service';
import { KlevuSearch } from './klevu-interfaces';
import { KlevuTrackService } from './klevu-track.service';

/**
 * ## Usage
 *
 * ```html
 * <a ... [klevuTrackClick]="{product: model, term: 'some term'}">...</a>
 * ```
 */
@Directive({
    selector: '[klevuTrackClick]',
    standalone: true
})
export class KlevuTrackClickDirective {
    @Input({
        required: true
    })
    klevuTrackClick!: KlevuSearch.ITrackSearchProductClickData;

    private klevuTrackService = inject(KlevuTrackService);

    /**
     * Click event listener
     */
    @HostListener('click')
    onClick() {
        const data = this.klevuTrackClick;
        if (data?.term) {
            this.klevuTrackService.trackSearchResultProductClick(data.term, data.product);
        }
    }
}
